export default __webpack_public_path__ + "static/media/defaultBannerNew.61463d7a.png";